import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheck, Quote } from 'lucide-react';
/**
 * Research-backed proof strip — verankert het product in echte leerwetenschap.
 * Geen testimonials in vroege toegang; wel concrete onderzoeksclaims.
 */
const PROOFS = [{
  stat: '2–3×',
  claim: 'effectiever dan blokoefenen',
  source: 'Roediger & Karpicke (2006) — over retrieval & spaced practice',
  accent: 'from-orange-500 to-amber-500'
}, {
  stat: '+14%',
  claim: 'leerwinst met adaptief oefenen',
  source: 'Pane et al. (2014) — RAND meta-analyse',
  accent: 'from-violet-500 to-fuchsia-500'
}, {
  stat: '67%',
  claim: 'beter behoud na uitleg-bij-fout',
  source: 'Kornell & Bjork (2008) — leerstrategie-onderzoek',
  accent: 'from-emerald-500 to-teal-500'
}];
export function ResearchProofSection() {
  return <section className="relative py-24 lg:py-32 bg-white overflow-hidden" data-id="element-680">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-681">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-682">
          <motion.div initial={{
          opacity: 0,
          y: 10,
          rotate: -3
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: -2
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-slate-900 text-white px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-[0.2em] mb-6 shadow-lg shadow-slate-900/20" data-id="element-683">
            <BookOpenCheck className="w-3.5 h-3.5 text-orange-400" data-id="element-684" />
            Onderzoek
          </motion.div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-6 tracking-tight" data-id="element-685">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500" data-id="element-686">
              Bewezen
            </span>
            , niet beloofd.
          </h2>
          <p className="text-lg text-slate-600 font-medium" data-id="element-687">
            We bouwen op leerwetenschap die al jaren bestaat — geen
            marketingclaims, gewoon onderzoek.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5" data-id="element-688">
          {PROOFS.map((p, idx) => <motion.div key={p.stat} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="relative bg-gradient-to-br from-slate-50 to-white rounded-2xl p-6 border border-slate-200 overflow-hidden" data-id="element-689">
              <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${p.accent}`} data-id="element-690" />
              <Quote className="absolute top-4 right-4 w-6 h-6 text-slate-200" strokeWidth={2} data-id="element-691" />
              <div className={`text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-br ${p.accent} mb-2 leading-none`} data-id="element-692">
                {p.stat}
              </div>
              <div className="text-base font-black text-slate-900 mb-3 leading-tight" data-id="element-693">
                {p.claim}
              </div>
              <div className="text-[11px] font-medium text-slate-500 leading-snug border-t border-slate-100 pt-3" data-id="element-694">
                {p.source}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}